const Brand = {
    MOSH: 'mosh',
    MOSHY: 'moshy',
} as const;
export type Brand = (typeof Brand)[keyof typeof Brand];

export default Brand;
